import { Mail01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';

import { EmailTemplatePreview } from 'components/EmailTemplatePreview/EmailTemplatePreview';
import { FormMessage, MessageType } from 'components/FormComponents';

import CandidateExperiencePreview from '../CandidateExperience/CandidateExperiencePreview';

const GeneralPreview = ({ brand }) => {
  return (
    <div className="flex flex-col gap-8">
      <FormMessage
        type={MessageType.Info}
        message="Below are two preview examples of your updated branding. These changes will be applied consistently across the platform, including the referee experience, candidate portal, and other touchpoints like reporting."
        noMargin
        closeable={false}
      />
      <div className="flex flex-col gap-8">
        <div className="flex items-center gap-2">
          <HugeiconsIcon icon={Mail01Icon} size="18" className="text-neutral-6" />
          <span className="text-neutral-7 text-[16px] font-regular">Email template preview</span>
        </div>
        <EmailTemplatePreview
          brand={brand}
          className="min-h-[18rem] w-full flex-1 lg:min-h-0"
          subject="Hi {{candidate}}, {{user}} at {{company}} has requested you to complete some employment checks"
          body="Congratulations on making it to the next phase of the hiring process!<br><br>
{{company}} partners with Checkmate to streamline our pre-employment screening process.<br><br>
This won't take long, and you'll be provided guidance on what's required at the next step.<br><br>
To start, please click below:<br><br>
"
          showActions
          showPreviewWarning={false}
        />
      </div>
      <CandidateExperiencePreview brand={brand} />
    </div>
  );
};

export default GeneralPreview;
